import React from "react";
import { createPortal } from "react-dom";
import l from "components/util/l";
import CommentForm from "components/util/helpers/CommentForm";

// Reopens the box the capture was commented in. It is the same CommentForm the overlay
// shows, so editing afterwards looks like what the user already did once — except the
// capture is already taken, so it only asks for the words.
const ConversationCommentEditor = ({
  imageUrl,
  comment = "",
  onChangeComment,
  onClose,
  onSave,
}) => createPortal(
  <div className="comment-editor-backdrop" onMouseDown={onClose}>
    <CommentForm
      isNew={false}
      text={comment}
      className="annotation-editor bg-white border shadow px-3 py-2"
      style={{ width: 320 }}
      onMouseDown={(e) => e.stopPropagation()}
      onChangeText={onChangeComment}
      onClose={onClose}
      onSave={onSave}
    >
      <div className="comment-editor-preview mb-2">
        <img src={imageUrl} alt={l("Captura de pantalla%CH027")} />
      </div>
    </CommentForm>
  </div>,
  document.body
);

export default ConversationCommentEditor;
